import {
  SEARCH_DUPLICATE,
  SEARCH_DUPLICATE_SUCCESS,
  SEARCH_DUPLICATE_FAIL,
} from "../actions/types";

const initialState = {
  userInputInfoId: null,
  lastSearchedAt: "",
  loading: false,
  error: null,
};

export default function searchReducer(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case SEARCH_DUPLICATE:
      return {
        ...state,
        userInputInfoId: null,
        lastSearchedAt: "",
        loading: true,
        error: null,
      };
    case SEARCH_DUPLICATE_SUCCESS:
      return {
        ...state,
        userInputInfoId: payload.userInputInfoId,
        lastSearchedAt: payload.lastSearchedAt,
        loading: false,
        error: null,
      };
    case SEARCH_DUPLICATE_FAIL:
      return {
        ...state,
        loading: false,
        error: payload.error,
      };
    default:
      return state;
  }
}
